import MaterialTreeItem from '@material-ui/lab/TreeItem';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Icon } from '../../icons';
import { IconButton } from '../../buttons';
import useStyles from './TreeItem.styles';
import { TreeItemExact } from '../../../models/TreeItem';

const TreeItem = ({ item, parentToggledActions, onActionToggle, ...materialProps }) => {
  const classes = useStyles();

  const [toggledActions, setToggledActions] = useState(parentToggledActions || {});

  const handleActionClick = useCallback(
    (event, action) => {
      event.preventDefault();
      const isToggled = toggledActions ? !toggledActions[action.id] : false;
      setToggledActions((previousToggledActions) => ({ ...previousToggledActions, [action.id]: isToggled }));
      onActionToggle();
      action.onClick(item, isToggled);
    },
    [item, onActionToggle, toggledActions]
  );

  useEffect(() => {
    setToggledActions(parentToggledActions);
  }, [parentToggledActions]);

  return (
    <MaterialTreeItem
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...materialProps}
      nodeId={String(item.id)}
      classes={{ root: classes.treeItemRoot }}
      label={
        <div className={classes.labelContainer} style={item.children ? undefined : { cursor: 'default' }}>
          {item.label}

          <span className={classes.actions}>
            {item.actions &&
              item.actions.map((action) => {
                const isToggled = action.icons.toggled && toggledActions && toggledActions[action.id];
                return (
                  <IconButton onClick={(event) => handleActionClick(event, action)} key={action.id} disabled={item.disabled}>
                    <Icon icon={isToggled ? action.icons.toggled : action.icons.default} />
                  </IconButton>
                );
              })}
          </span>
        </div>
      }>
      {item.children &&
        item.children.map((child) => <TreeItem key={child.id} item={child} parentToggledActions={toggledActions} onActionToggle={onActionToggle} />)}
    </MaterialTreeItem>
  );
};

TreeItem.propTypes = {
  item: TreeItemExact,
  onActionToggle: PropTypes.func.isRequired,
  parentToggledActions: PropTypes.objectOf(PropTypes.bool),
};

TreeItem.defaultProps = {
  item: undefined,
  parentToggledActions: {},
};

export default React.memo(TreeItem);
